import styled, { css } from "styled-components";

export const AlertStyle = styled.div`
  display: flex;
  padding: 24px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  text-align: left;
  color: #000;
  border-radius: 16px;
  leading-trim: both;
  text-edge: cap;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */

  ${(props) => props.type === "warning" && css`
    background: #FFE39B;
  `}

  ${(props) => props.type === "success" && css`
    background: #B5E7B8;
  `}

  ${(props) => props.type === "error" && css`
    background: #F4B9B9;
  `}

  ${(props) => props.size === "sm" && css`
    width: fit-content;
    margin: 0 auto;
    padding: 20px 24px;
  `}
`;
